import i18n from "@/i18n";

export const contentFields = [
    {
        key: "status",
        label: ""
    },
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        tdClass: "td-sm"
    },
    {
        key: "layer",
        label: i18n.t("background.layer"),
        tdClass: "td-sm"
    },
    {
        key: "x",
        label: i18n.t("background.posX"),
        tdClass: "td-sm"
    },
    {
        key: "y",
        label: i18n.t("background.posY"),
        tdClass: "td-sm"
    },
    {
        key: "actions",
        label: ""
    }];
